// src/api/user-management-api.ts
import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { SourceTypes } from "@common/types/server-list-types";

export const getSourceById = async (
  namespace: string,
  sourceId: string,
  shouldRequestNodeset: boolean,
  signal?: AbortSignal,
) => {
  const url = clientConfigurationUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<SourceTypes>(
      `${url}/api/v3/ns/${namespace}/sources/${sourceId}?include_nodeset=${shouldRequestNodeset}`,
      {
        headers: headers,
        signal,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        (typeof err.response?.data?.detail === "string" &&
          err.response?.data?.detail) ||
          (typeof err.response?.data?.message === "string" &&
            err.response?.data?.message) ||
          "Failed to fetch source information. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while fetching source information.",
      );
    }
  }
};
